import { render, staticRenderFns } from "./PastDraws.vue?vue&type=template&id=7f4e054a&scoped=true&"
import script from "./PastDraws.vue?vue&type=script&lang=js&"
export * from "./PastDraws.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/past-draws.scss?vue&type=style&index=0&id=7f4e054a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4e054a",
  null
  
)

export default component.exports